export const widgetName = "custom-html-code";
export const widgetDisplayName = "Custom HTML code";
export const widgetCategory = "Custom widgets";
export const widgetSelector = "custom-html";
export const widgetRuntimeSelector = "custom-html-runtime";
export const widgetEditorSelector = "custom-html-editor";
export const widgetIconClass = "widget-icon widget-icon-api-management";